// extracted by mini-css-extract-plugin
module.exports = {"categoriesContainer":"categories_categoriesContainer__2zKCw","categoryItem":"categories_categoryItem__xJnbE"};